<!-- 我的日报 -->
<template>
    <basicContainer>
        <div class="el-card easyCruds avue-crud">
                      <el-row class='el-card__body'>
                      <el-col :span='8'>
                          <label for="sj" class="el-form-item__label" style="width: 80px;">时间:</label>
                          <div class="el-form-item__content" style="margin-left: 80px;">
                              <el-date-picker
                            v-model="rbsj"
                            ref="picker"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="diaryTableReload"
                            :picker-options="pickerOptions">
                            </el-date-picker>
                          </div>

                      </el-col>
                      <el-col :span='6' class="tc">
                          <el-radio-group v-model="yzORyy" @change="changerbfw">
                            <el-radio-button label="yz">近一周</el-radio-button>
                            <el-radio-button label="yy">近一月</el-radio-button>
                            </el-radio-group>
                      </el-col>
                  </el-row>
                  </div>

                <easyCruds
                        ref="diaryTable"
                        :tableInfo="diaryForm.mainTable"
                         @diaryViewRow="diaryViewRow"
                         @mainTableReload="diaryTableReload"
                        >
                </easyCruds>
    </basicContainer>
</template>

<script>
import { dateFormat } from '@/framework/util/date'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'MyDiary',
  data() {
    return {
      yzORyy: 'yz',
      searchTime: {}, // 我的日报搜索条件
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      rbsj: [dateFormat(new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd'), dateFormat(new Date(new Date().getTime()), 'yyyy-MM-dd')], // 我的日报时间
      diaryForm: {
        mainTable: {
          buttonSetting: {
            allowView: false,
            allowEdit: false,
            allowDelete: false
          },
          header: {},
          table: {
            loading: false,
            height: 550,
            stripe: true,
            selection: false,
            index: false,
            columns: [
              {
                label: '填写日期',
                prop: 'txrq',
                minWidth: 120
              },
              {
                label: '姓名',
                prop: 'xm',
                minWidth: 120
              },
              {
                label: '直属主管',
                prop: 'zszg',
                minWidth: 120
              },
              {
                label: '总工时',
                prop: 'zsc',
                minWidth: 120
              },
              {
                label: '任务完成率',
                prop: 'rwwcl',
                minWidth: 120
              },
              {
                label: '主管评分',
                prop: 'zgpf',
                minWidth: 120
              },
              {
                label: '主管评价',
                prop: 'zgpj',
                minWidth: 200
              }
            ],
            operation: {
              width: '80',
              operations: [
                {
                  title: '查看',
                  clickEvent: 'diaryViewRow'
                }
              ]
            },
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['GongHao'])
  },
  mounted() {
    this.diaryTableReload(this.rbsj)
  },
  methods: {
    //   我的日报页面tab切换周/月
    changerbfw(value) {
      if (value == 'yz') {
        const end = dateFormat(new Date(), 'yyyy-MM-dd')
        const start = dateFormat(new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd')
        this.rbsj = [start, end]
        this.diaryTableReload()
      } else {
        const end = dateFormat(new Date(), 'yyyy-MM-dd')
        const start = dateFormat(new Date(new Date().getTime() - 3600 * 1000 * 24 * 30), 'yyyy-MM-dd')
        this.rbsj = [start, end]
        this.diaryTableReload()
      }
    },
    // 日报分页查询
    diaryTableReload(params) {
      params = params || {}
      this.searchTime.kssj = this.rbsj[0]
      this.searchTime.jssj = this.rbsj[1]
      this.searchTime.creator = this.$store.getters.GongHao
      console.log(this.$store.getters)
      this.diaryForm.mainTable.table.loading = true
      //   默认查询时间为最近一周
      if (!this.searchTime.kssj) { this.searchTime.kssj = dateFormat(new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd') }
      if (!this.searchTime.jssj) { this.searchTime.jssj = dateFormat(new Date(new Date().getTime()), 'yyyy-MM-dd') }
      if (!params.pageSize) { params.pageSize = 10 }
      if (!params.pageNum) { params.pageNum = 1 }
      this.$http.post('/RbReport/queryNewRbReportYgxq', this.searchTime, { params: {
        pageSize: params.pageSize,
        pageNum: params.pageNum,
        zh: this.$store.getters.userInfo.subject.id,
        kssj: this.rbsj[0],
        jssj: this.rbsj[1]
      }}).then(response => {
        this.diaryForm.mainTable.table.loading = false
        if (response.code === 200) {
          response.data.records
            .filter(
              item =>
                item.taskAssigneeName === '' ||
                  item.taskAssigneeName === null ||
                  item.taskAssigneeName === ''
            )
            .forEach(item => {
              item.taskAssigneeName = item.lastExecutorName
            })
            // 成功之后的数据

          this.diaryForm.mainTable.table.tableData = response.data.records
          this.diaryForm.mainTable.table.paging.total =
              response.data.total || response.data.records.length
          return true
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 我的日报查看
    diaryViewRow(index, row) {
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.id,
          processInstanceId: row.processInstanceId,
          taskId: null,
          formId: null,
          pageKey: 'VIEW'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.iframeMain{
  height: 70vh;
}
.tc{
    text-align: center;
}
</style>
